// import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import { cn } from '@/libs/utils';

export default function BankAccountsGroup({
  form,
  name = 'bankAccounts',
  nestedName = 'generalData',
  disabled = false,
  className,
}) {
  // const { t } = useTranslation(['forms', 'messages']);

  const handleBlur = (fieldName, value, maxLength) => {
    if (!value) return;

    let formattedValue = value;

    if (fieldName === 'part2') {
      formattedValue = value.padStart(maxLength, '0');
    }

    const currentValues = form.getFieldValue([nestedName, name]) || {};

    const updatedValues = {
      ...currentValues,
      [fieldName]: formattedValue,
    };

    form.setFieldsValue({
      [nestedName]: {
        ...form.getFieldValue(nestedName),
        [name]: updatedValues,
      },
    });
  };

  return (
    <div className={cn('grid grid-cols-[80px_1fr_80px] gap-4', className)}>
      <Form.Item name={[nestedName, name, 'part1']} noStyle>
        <Input
          maxLength={3}
          placeholder="XXX"
          type="number"
          onBlur={(e) => handleBlur('part1', e.target.value, 3)}
          disabled={disabled}
        />
      </Form.Item>

      <Form.Item name={[nestedName, name, 'part2']} noStyle>
        <Input
          maxLength={13}
          placeholder="XXXXXXXXXXXXX"
          type="number"
          onBlur={(e) => handleBlur('part2', e.target.value, 13)}
          disabled={disabled}
        />
      </Form.Item>

      <Form.Item name={[nestedName, name, 'part3']} noStyle>
        <Input
          maxLength={2}
          placeholder="XX"
          type="number"
          onBlur={(e) => handleBlur('part3', e.target.value, 2)}
          disabled={disabled}
        />
      </Form.Item>
    </div>
  );
}
